/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MfSelector3fcEnum {
    BIGGEST = 'biggest',
    ALL = 'all',
}